package game.entity

import game.*
import view.Terminal

enum class Direction {
    North,
    South,
    East,
    West
}

open class Entity(
    var id: String = "",
    var type: String = "",
    var col: Int = 0,
    var row: Int = 0,
    var width: Int = 1,
    var height: Int = 1,
//    var direction: Direction = Direction.North
) {
    var params = ""
    var tag = ""
    var fixed = false

    var sprite: CharSprite? = null
        set(value) {
            field = value
            frame = 0
            frameTimer = 0
        }
    var frame = 0
    var frameTimer = 0
    var onAnimationComplete: ((Entity) -> Unit)? = null
    var damageCoolDown = 0

    open val deathSound: String? = "enemy-death"

    fun tick(game: Game, room: Room) {
        if (sprite != null) {
            frameTimer++

            if (frameTimer > sprite!!.frames[frame].duration) {
                frame++
                frameTimer = 0
                if (frame >= sprite!!.frames.size) {
                    frame = 0
                    onAnimationComplete(game)
                    onAnimationComplete?.invoke(this)
                }
            }
        }

        if (damageCoolDown > 0) {
            damageCoolDown--
        }

        onTick(game, room)
    }


    open fun onInit(game: Game, room: Room) {}
    open fun onRemove(game: Game, room: Room) {}
    open fun onTick(game: Game, room: Room) {}
    open fun onAnimationComplete(game: Game) {}
    open fun onAttacked(game: Game, weapon: Weapon) {}
    open fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        return true
    }

    fun render(terminal: Terminal, colOffset: Int, rowOffset: Int) {
        if (damageCoolDown == 0 || damageCoolDown / 5 % 2 == 0) {
            sprite?.render(terminal, col + colOffset, row + rowOffset, frame)
        }
    }

    fun move(direction: Direction, magnitude: Int = 1) {
        when (direction) {
            Direction.North -> row -= magnitude
            Direction.South -> row += magnitude
            Direction.East -> col += magnitude
            Direction.West -> col -= magnitude
        }
    }

    fun intersects(col: Int, row: Int, width: Int = 1, height: Int = 1) =
        this.col < col + width &&
                this.col + this.width > col &&
                this.row < row + height &&
                this.row + this.height > row


    fun offScreen(): Boolean {
        return col < 0 || row < 0 || col >= ROOM_WIDTH || row >= ROOM_HEIGHT
    }

    fun contains(col: Int, row: Int) =
        col in this.col until this.col + width && row in this.row until this.row + height

    fun killMe(game: Game) {
        game.currentRoom.removeEntity(this)

        val deathAnimation = EntityDeath(this, deathSound)

        game.currentRoom.addEntity(deathAnimation)
    }
}